import Nav from "./../Page/Share/Nav/Nav";
const Post3 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Duck's Store Branding Design
          </h2>
          {/* items?.Description */}
          <p>

          </p>
          {/* img section */}
          <img src="https://i.ibb.co/vBMw9hS/2.jpg" alt="" />
          <img src="https://i.ibb.co/vLrHjB5/3-1.jpg" alt="" />
          <img src="https://i.ibb.co/5KpDBR0/3.jpg" alt="" />
          <img src="https://i.ibb.co/jb1J5zs/4.jpg" alt="" />
          <img src="https://i.ibb.co/MVT4JRH/5.jpg" alt="" />
          <img src="https://i.ibb.co/jLNH1B3/6.jpg" alt="" />
          <img src="https://i.ibb.co/0F3fsY5/7.png" alt="" />
          <img src="https://i.ibb.co/HnQPHS0/8.jpg" alt="" />
          <img src="https://i.ibb.co/dcF9mPS/9.png" alt="" />
          <img src="https://i.ibb.co/KyrDbzJ/10.jpg" alt="" />
          <img src="https://i.ibb.co/QKdzmTM/1.jpg" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post3;
